import { render } from "./SiteIntro.vue?vue&type=template&id=a1f512d4"
import script from "./SiteIntro.vue?vue&type=script&lang=js"
export * from "./SiteIntro.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__